import React from "react";
import { useFacility } from "@/context/FacilityContext";
import { PageHeader } from "@/components/common/PageHeader";
import { AuditViewer } from "@/components/common/AuditViewer";

export default function TenantAudit() {
  const { activeId } = useFacility();
  return (
    <div data-testid="tenant-audit-page">
      <PageHeader title="Audit Logs" subtitle="Administrative activity within your organisation." />
      <AuditViewer query={activeId ? `&facility_id=${activeId}` : ""} />
    </div>
  );
}
